import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";
import media from "utils/styleUtils";

interface IProps {
  fullWidth?: boolean;
  small?: boolean;
  valid?: boolean;
  invalid?: boolean;
  largeText?: boolean;
  white?: boolean;
  focused?: boolean;
}

const PhoneNumberInput = styled("input")<IProps>`
  background: transparent;
  font-size: 3rem;
  text-align: center;
  box-sizing: border-box;
  max-height: 80px;
  border-radius: 0;

  ${({ largeText }) =>
    largeText
      ? `
          font-size: 4rem;
  `
      : ``}
    font-family: ${theme.fontFamily.black};
    color: ${theme.color.primary};
    border: none;
    border-bottom: 1px solid ${theme.color.primary};
    transition: ${theme.global.transition};

  ${({ focused }) =>
    focused
      ? `
      border-bottom: 3px inset ${theme.color.primary};
      transition: font-size 0.5s
      font-size: 5.6rem !important;

  `
      : ``}
  ${({ fullWidth }) => (fullWidth ? `width: 100%;` : ``)};

  ${({ small }) => (small ? `font-size: 20px;` : ``)};
  ${({ white }) =>
    white
      ? `
      border-bottom: 1px solid ${theme.color.white}; 
      color: ${theme.color.white};`
      : ``};

  ${({ valid }) =>
    valid
      ? `
      color: ${theme.color.tertiary};
      border-bottom: 1px solid ${theme.color.tertiary};
    `
      : ``};

  ${({ invalid }) =>
    invalid
      ? `
      color: ${theme.color.red};
      border-bottom: 1px solid ${theme.color.red};
    `
      : ``};

  ${media.ipad`
    font-size: 3rem !important;
    ${({ focused }) => focused && `font-size: 4.5rem !important;`}
  `};
`;

PhoneNumberInput.defaultProps = {
  readOnly: true
};

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/components/common/PhoneNumberInput/PhoneNumberInput.tsx